import { Theme } from './types'

/**
 * Theme capabilities configuration
 * Defines what features each theme supports
 */
export interface ThemeCapabilities {
  supportsDarkMode: boolean
}

/**
 * Configuration mapping themes to their capabilities
 * Add new themes here with their supported features
 */
export const THEME_CAPABILITIES: Record<Theme, ThemeCapabilities> = {
  [Theme.AP]: {
    supportsDarkMode: false,
  },
  [Theme.Cash]: {
    supportsDarkMode: false,
  },
  [Theme.Pegasus]: {
    supportsDarkMode: true,
  },
  [Theme.Kelpie]: {
    supportsDarkMode: true,
  },
  [Theme.KelpieMint]: {
    supportsDarkMode: true,
  },
}

/**
 * Check if a theme supports dark mode
 * @param theme - The theme to check
 * @returns true if the theme supports dark mode, false otherwise
 */
export const themeSupportsDarkMode = (theme: Theme): boolean => {
  return THEME_CAPABILITIES[theme]?.supportsDarkMode ?? false
}
